import HalfConfPoster from "../../../../MDX/Articles/2020-05-22 My learnings from HalfStack's Conference/HalfConf";
import * as React from 'react';
export default {
  HalfConfPoster,
  React
};